import {
    Avatar,
    Flex,
    Grid,
    pxArrayToRem,
    useStyles,
} from '@archipro-design/aria';
import * as S from '@modules/design-board/component/manage/collaborator-overview/CollaboratorsOverview.style';
import { getNameInitials } from '@modules/user/util/get-name-initials';

export const CollaboratorAvatar = ({
    name,
    imageUrl,
}: {
    name: string;
    imageUrl: string;
}) => {
    const { css } = useStyles();

    return (
        <Grid
            className={css(S.AvatarRoot)}
            columns={`${pxArrayToRem([48, 180])}`}
        >
            <Flex className={css(S.GridItemWrapper)}>
                <Avatar
                    initials={getNameInitials(name)}
                    imageFit={'contain'}
                    image={imageUrl}
                    size={48}
                />
            </Flex>
            <Flex className={css(S.GridItemWrapper)}>
                <p className={css(S.CollaboratorName)} title={name}>
                    {name}
                </p>
            </Flex>
        </Grid>
    );
};
